<template>
  <div class="row">
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <Subtitle
            @exibirVermelhos="handleExibirVermelhos"
            @exibirVerdes="handleExibirVerdes"
            :setRed="setRed"
            @resetarNome="setRed = false"
          ></Subtitle>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="envio-app-acs-pec"
          >
          </download-files>
        </div>
      </div>
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        :ultimaAtualizacao="ultimaAtualizacao"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import TabelaCadastros from './TabelaCadastros.vue'
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import Subtitle from './Subtitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'EnvioApp',
  components: {
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
  },
  mixins: [utils],

  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      cadastros: [],
      cadastrosOriginais: [],
      setRed: false,
      page: 1,
      perPage: 10,
      pages: [],
      nome: '',
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      total_de_registros_da_tabela: 0,
      loading: false,
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais

      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
      this.total_de_registros_da_tabela = this.cadastros.length
    },
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false, this.situacao)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false, this.situacao)
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },
    // Busca os dados referentes a cidade ao abrir a página
    buscarSincronizacao() {
      this.loading = true
      this.$api
        .get('/app/sincronizacao-app-acs/' + this.cod_ibge)
        .then((response) => {
          this.cadastros = response.data
          this.cadastrosOriginais = response.data
          this.filtros(true, false)
          this.setRed = true
          this.loading = false
        })
        .catch(function (error) {
          console.log(error)
          this.loading = false
        })
    },

    generatePdf() {
      Functions.generatePdf(this.displayedCadastros)
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarSincronizacao()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style></style>
